export class Login {
  public $api: any;
  public $axios: any;
  public $config: any;
  public $auth: any;
  public $i18n: any;
  public $customGtm: any;
  public $store: any;
  public $globals: any;
  public router: any;
  public localePath: any;
  public backendLink: any;
  public $dialogs: any;

  constructor(app, router, localePath) {
    const {
      $api,
      $axios,
      $config,
      $auth,
      $i18n,
      $customGtm,
      $store,
      $globals,
      $backendLink,
      $dialogs,
    } = app;
    this.$api = $api;
    this.$axios = $axios;
    this.$config = $config;
    this.$auth = $auth;
    this.$i18n = $i18n;
    this.$customGtm = $customGtm;
    this.$store = $store;
    this.$globals = $globals;
    this.router = router;
    this.localePath = localePath;
    this.backendLink = $backendLink;
    this.$dialogs = $dialogs;
  }

  public loginHandler(path?: string) {
    if (this.$auth.user) {
      if (this.$auth.user?.roles[0] === 'user') {
        return this.logout();
      } else {
        return this.login('', '', path);
      }
    } else {
    }
  }

  public serverRedirectToLogin(
    req: any,
    route: any,
    redirect: any,
    isExternal?: boolean,
  ) {
    const tenantName = this.$axios.defaults.headers.common['X-Tenant-ID'];
    const backendUrl = this.backendLink;
    const redirectURL =
      `${
        this.$config.application?.tenants[tenantName]?.default?.autoLogin
          ?.hasSecureLoginUrl
          ? 'https://'
          : 'http://'
      }` +
      req.headers.host +
      route.fullPath;

    const href = `${backendUrl}/login/${tenantName}?lang=${
      this.$i18n.locale.value || this.$i18n.locale
    }&redirectUrl=${encodeURIComponent(redirectURL)}`;
    return redirect(href, { external: !!isExternal });
  }

  public async login(
    articleId?: number | string | null,
    purchaseType?: string,
    redirectUrl?: string,
    typeId?: number,
    subTypeId?: number,
  ) {
    this.$dialogs.loader = true;
    const tenantName = this.$store.state.tenant;
    const backendUrl = this.backendLink;
    const isPartner = this.$api.tenant?.default?.isPartner;
    this.$customGtm.track({
      ET: 'Event',
      EA: 'display login Popup',
      EC: 'Authentication Process',
      EL: 'login Popup',
      adobeTrack: {
        adobeET: 'notification',
        adobeData: {
          notification_action: 'displayed',
          notification_message: this.$i18n.t('loginDialog.title'),
          notification_area: true,
          notification_details: 'login portal',
        },
      },
    });

    const trackingData = {
      ET: 'Event',
      EN: 'login_start',
      AT: 'login',
      EC: 'Authentication Process'
    };
    this.fireTrackingEvent(trackingData)

    let locationHref = redirectUrl
      ? location.origin + redirectUrl
      : location.href;
    if (articleId) {
      const articleIdQueryParam = locationHref.includes('?')
        ? `&articleId=${articleId}`
        : `?articleId=${articleId}`;
      locationHref += articleIdQueryParam;
    }
    if (purchaseType) {
      locationHref += '&purchaseType=' + purchaseType;
    }
    if (typeId) {
      const typeIdQueryParam = locationHref.includes('?')
        ? `&typeID=${typeId}`
        : `?typeID=${typeId}`;
      locationHref += typeIdQueryParam;
    }
    if (subTypeId) {
      const typeIdQueryParam = locationHref.includes('?')
        ? `&subTypeId=${subTypeId}`
        : `?subTypeId=${subTypeId}`;
      locationHref += typeIdQueryParam;
    }
    if (
      isPartner &&
      this.$globals.enabledFeatures.partnerLoginFlow === 'true'
    ) {
      let loginOptionsObject = await this.$api.endPoints.getPartnerLoginOptions(
        locationHref,
        this.$i18n.locale.value || this.$i18n.locale,
        tenantName,
      );
      let loginOptions = JSON.stringify(loginOptionsObject);
      sessionStorage.setItem('loginOptionsObject', loginOptions);
      this.$store.commit('setLoginOptions', loginOptions);
      this.$dialogs.loader = false;
      if (this.$api.tenant?.default?.multipleLoginOptionsFlow2) {
        this.$dialogs.openLoginOptionsDialog(loginOptionsObject, 'login');
      } else {
        this.router.push(this.localePath('/register'));
      }
    } else {
      this.$dialogs.loader = false;
      const href = `${backendUrl}/login/${tenantName}?lang=${
        this.$i18n.locale.value || this.$i18n.locale
      }&redirectUrl=${encodeURIComponent(locationHref)}`;
      location.href = href;
    }
  }

  public register(redirectPage: string) {
    const tenantName = this.$axios.defaults.headers.common['X-Tenant-ID'];
    const backendUrl = this.backendLink;
    const locationHref = location.origin + redirectPage;
    const href = `${backendUrl}/register/${tenantName}?lang=${
      this.$i18n.locale.value || this.$i18n.locale
    }&redirectUrl=${encodeURIComponent(locationHref)}`;
    location.href = href;
  }

  public async addLogoutListner() {
    if (process.client) {
      const tokenKey = '_token.mcp';

      window.addEventListener('storage', (event) => {
        if (event.storageArea !== localStorage) {
          return;
        }
        if (event.key === `auth.${tokenKey}`) {
          location.reload();
        }
      });
    }
  }

  public async logout(specialRedirection = false) {
    console.log('LOGOUT FROM LOGIN');
    this.$auth.logout(specialRedirection);
  }

  public fireTrackingEvent( trackingData: {}) {
    this.$customGtm.track(trackingData);
  }
}

export default defineNuxtPlugin(async () => {
  const login = new Login(useNuxtApp(), useRouter(), useLocalePath());
  return {
    provide: {
      login,
    },
  };
});
